import React, { Component, Fragment } from 'react'

import { Container, Row, Col, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import parkease from '../../assets/images/product/parkease2.png';
import cathomis from '../../assets/images/product/cathomis.PNG';
import pospresso from '../../assets/images/product/pospresso2.png';
import posplus from '../../assets/images/product/posplus2.png';
import tradehub from '../../assets/images/product/tradehub1.png';


class FeaturedProducts extends Component {

  render() {

    return (

      <Fragment>

        <Container className="text-center" fluid={true}>

          <div className="section-title text-center mb-55">
            <h2>OUR PRODUCTS</h2>
            <p>
              Smart software solutions made to help your business run faster and better.
            </p>
          </div>
<Row className="g-3 row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5">

            {/* PARKEASE */}
            <Col>
              <Link to="/parkease">
                <Card className="image-box card h-100">
                  <img className="center" src={parkease} alt="Parkease" />
                  <Card.Body>
                    <p className="product-name-on-card btn btn-primary btn-sm">PARKEASE</p>



                   
                   {/* <p className="product-name-on-card">
                      Our Software for Parking
                    </p>*/}
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            {/* CAT HOMIS */}
            <Col>
              <Link to="/cat_homis">
                <Card className="image-box card h-100">
                  <img className="center" src={cathomis} alt="Cathomis" />
                  <Card.Body>
                    <p className="product-name-on-card btn btn-primary btn-sm">CAT HOMIS</p>
                      {/* <p className="product-name-on-card">
                      Our software for restaurants and room booking
                    </p>*/}
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            {/* POSPRESSO */}
            <Col>
              <Link to="/pospresso">
                <Card className="image-box card h-100">
                  <img className="center" src={pospresso} alt="Pospresso" />
                  <Card.Body>
                    <p className="product-name-on-card btn btn-primary btn-sm">POSPRESSO</p>
                      {/* <p className="product-name-on-card">
                      Our software for restaurants
                    </p>*/}
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            {/* POSPRESS PLUS */}
            <Col>
              <Link to="/pospresso_plus">
                <Card className="image-box card h-100">
                  <img className="center" src={posplus} alt="Posplus" />
                  <Card.Body>
                    <p className="product-name-on-card btn btn-primary btn-sm">POSPRESS PLUS</p>
                      {/* <p className="product-name-on-card">
                      Restaurant, Bar, Parking and Washbay
                    </p>*/}
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            {/* TRADE HUB */}
            <Col>
              <Link to="/tradehub">
                <Card className="image-box card h-100">
                  <img
                    className="center"
                    src={tradehub}
                    alt="Trade Hub"
                  />
                  <Card.Body>
                    <p className="product-name-on-card btn btn-primary btn-sm">TRADE HUB</p>
                        {/*<p className="product-name-on-card">
                      Buying & Selling
                    </p>*/}
                  </Card.Body>
                </Card>
              </Link>
            </Col>

          </Row>

        </Container>

      </Fragment>

    )

  }

}

export default FeaturedProducts